var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "shipment-summary"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-top": "-18px"
    }
  }, [_c('legend', [_vm._v("Bin Summary")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.getBinDetails.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bin ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-cart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.binId),
      expression: "binId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('binId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bin ID",
      "name": "binId",
      "id": "binId"
    },
    domProps: {
      "value": (_vm.binId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.binId = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.binIdError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.binIdErrorMSG))]) : _vm._e(), _vm._v(" "), (_vm.binIdErrorForAlpha) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.binIdErrorForAlphaMSG))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('b-form-fieldset', [_c('label', [_c('br')]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" \n                      "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")]), _vm._v(" \n                    ")])], 1)], 1)])])]), _vm._v(" "), (_vm.showDataTable) ? _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "80%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Bin Id :- " + _vm._s(this.binId))])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Total AWB:- " + _vm._s(_vm.binDetails.length))])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "80%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Next Hub Location")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.binDetails), function(data, index) {
    return (_vm.binDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbnumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.nextHubName))])]) : _vm._e()
  }), _vm._v(" "), (_vm.binDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e()], 1)], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6407dbaf","hasScoped":true}!./src/views/components/PalletReportPages/BinSummary/BinSummary.html
// module id = 1328
// module chunks = 2